export const CorrespondenceRoutes = {
    correspondence: (origin: string) => `${origin}/correspondence/search`,
    correspondenceAttachments: (origin: string) => `${origin}/correspondence/attachment`,
    correspondenceTracking: (origin: string) => `${origin}/correspondence/tracking`,
    correspondenceAttachmentsDownloadLink: (origin: string, id: string) =>
        `${origin}/correspondence/attachment/${id}/download`,
    correspondenceAttachmentsPreviewLink: (origin: string, id: string) =>
        `${origin}/correspondence/attachment/${id}/preview`,
};
